import { FunctionComponent } from "react";

interface DurationSelectProps {
    id: string,
    title: string,
    durationSeconds: number,
    maxMinutes?: number,
    onDurationChange: (value: number) => void,
}

const defaultSecondOptions = [0, 10, 20, 30, 40, 50];

const DurationSelect: FunctionComponent<DurationSelectProps> = (props) => {
    let { id, title, durationSeconds, maxMinutes = 30, onDurationChange } = props;
    let minutes = Math.min(Math.floor(durationSeconds / 60), maxMinutes);
    let seconds = Math.floor((durationSeconds % 60) / 10) * 10;
    let minuteOptions = Array.from({ length: maxMinutes + 1 }, (_, index) => index);
    let changeMinutes = (value: number) => onDurationChange(value * 60 + seconds);
    let changeSeconds = (value: number) => onDurationChange(minutes * 60 + value);
    return <>
        <label>{title}</label>
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <select
                className="form-control"
                id={`${id}-minutes`}
                value={minutes}
                style={{ width: "80px", flex: "0 0 80px" }}
                onChange={event => changeMinutes(+event.target.value)}
            >
                {minuteOptions.map(option => <option key={option} value={option}>{option}</option>)}
            </select>
            <span className="status-block" style={{ whiteSpace: "nowrap" }}>minutes</span>
            <select
                className="form-control"
                id={`${id}-seconds`}
                value={seconds}
                style={{ width: "80px", flex: "0 0 80px" }}
                onChange={event => changeSeconds(+event.target.value)}
            >
                {defaultSecondOptions.map(option => <option key={option} value={option}>{option}</option>)}
            </select>
            <span className="status-block" style={{ whiteSpace: "nowrap" }}>seconds</span>
        </div>
    </>
}

export default DurationSelect;
